export { ReactComponent as MynewsdeskLogo } from '../svg/mynewsdesk-logo.svg?react';
export { ReactComponent as MynewsdeskLogoInverted } from '../svg/mynewsdesk-logo-inverted.svg?react';
